import React from 'react'

import { Button, Stack, styled } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { LoadingButton } from '@mui/lab'
import ModalsWrapper from './dialog-wrapper'

interface ConfirmDialogProps {
    open: boolean
    handleClose: () => void
    onConfirm: () => void
    isLoading?: boolean
    content?: React.ReactNode
}

/**
 * Secondary confirm dialog version which doesnt require a child, so we can put it anywhere in the tree
 */
const ConfirmDialogV2: React.FC<ConfirmDialogProps> = ({ open, handleClose, onConfirm, isLoading, content }) => {
    const { t } = useTranslation()

    return (
        <ModalsWrapper
            sx={{
                zIndex: 9999,
            }}
            open={open}
            title={t('TEXT_CONFIRM_DIALOG_TITLE', 'Vennligst bekreft')}
            handleClose={handleClose}
            fullWidth={true}
            maxWidth="sm"
            body={content ? <ContentWrapper spacing={0}>{content}</ContentWrapper> : undefined}
            actions={
                <ActionWrapper flexDirection="row" justifyContent="space-between" width="100%" mb={2} mx={1.5}>
                    <Button
                        variant="outlined"
                        onClick={(e) => {
                            e.stopPropagation()
                            handleClose()
                        }}
                        color="secondary"
                    >
                        {t('TEXT_BACK', 'Tilbake')}
                    </Button>
                    <LoadingButton
                        loading={Boolean(isLoading)}
                        disabled={isLoading}
                        variant="contained"
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation()
                            onConfirm()
                        }}
                        sx={(theme) => ({
                            [theme.breakpoints.down('sm')]: {
                                marginTop: theme.spacing(2),
                            },
                        })}
                    >
                        {t('TEXT_YES', 'JA')}
                    </LoadingButton>
                </ActionWrapper>
            }
        />
    )
}

export default ConfirmDialogV2

const ActionWrapper = styled(Stack)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
    },
}))

const ContentWrapper = styled(Stack)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        width: 'auto',
        maxWidth: '23.4375rem',
        margin: '1rem',
    },
}))
